const cart = document.querySelector('.js-cart');
const plusmins = [...document.querySelectorAll('.quantity-selector__button')];
const inputs = [...document.querySelectorAll('.quantity-selector__input')];
const addtocart = document.querySelector('.product-form--atc-button');


const calculateFreeDelivery = () => {
    console.log('calculating..');
    const orderValueRaw = document.querySelector('.js-cart-subtotal')?.querySelector('.money').innerHTML;
    const orderValueRawProduct = document.querySelector('.js-product-total')?.innerHTML;
    let orderValue = 0;

    if(typeof orderValueRaw !== 'undefined') {
        orderValue = parseInt(orderValueRaw.replace('€', '').replace(',', ''));
    }else if(orderValueRawProduct){
        orderValue = parseInt(orderValueRawProduct.replace('€', '').replace(',', ''));
    }

    const limit = document.querySelector('.js-cart-till-free');
    const limitElement = document.querySelector('.js-cart-till-free-element');
    const limitPrice = document.querySelector('.js-cart-till-price');
    const deliveryCosts = document.querySelector('.js-cart-delivery-costs');

    if (limit) {
        const limitValue = parseInt(limit.dataset.limit);
        const difference = ((limitValue - orderValue) / 100).toFixed(2);

        limitPrice.innerHTML = '€' + difference.replace('.', ',');

        if (orderValue > limitValue) {
            limitElement.classList.add('d-none');
            deliveryCosts.querySelector('.money').innerHTML = deliveryCosts.dataset.free;
        } else {
            limitElement.classList.remove('d-none');
            deliveryCosts.querySelector('.money').innerHTML = deliveryCosts.dataset.original;
        }
    }
}

if(cart) {
    if (plusmins) {
        plusmins.map(plusmin => {
            plusmin.addEventListener('click', () => {
                setTimeout(calculateFreeDelivery, 2000);
            });
        });
    }

    if (inputs) {
        inputs.map(input => {
            input.addEventListener('change', () => {
                setTimeout(calculateFreeDelivery, 2000);
            });
        });
    }

    if (addtocart) {
        addtocart.addEventListener('click', () => {
            setTimeout(calculateFreeDelivery, 2000);
        });
    }

    setTimeout(
        calculateFreeDelivery
        , 2000);

}
